import PlanDetail from "views/admin/PlanDetail";
import Profile from "views/examples/Profile";
import AddTenant from "views/tenantAdmin/AddTenant";
import AgentChat from "views/tenantAdmin/AgentChat";
import BranchDetail from "views/tenantAdmin/BranchDetail";
import BranchForm from "views/tenantAdmin/BranchForm";
import CategoriesList from "views/tenantAdmin/CategoriesList";
import CategoryDetail from "views/tenantAdmin/CategoryDetail";
import EditTenant from "views/tenantAdmin/EditTenant";
import PaymentCancel from "views/tenantAdmin/PaymentCancel";
import PaymentSuccess from "views/tenantAdmin/PaymentSuccess";
import SubscriptionPage from "views/tenantAdmin/SubscriptionPage";
import TenantAdminDashboard from "views/tenantAdmin/TenantAdminDashboard";
import TenantPlanUsage from "views/tenantAdmin/TenantPlanUsage";


var tenantRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: <TenantAdminDashboard />,
    layout: "/tenant",
  },
  {
    path: "/planUsage",
    name: "Plan Usage",
    icon: "ni ni-chart-bar-32 text-primary ",
    component: <TenantPlanUsage />,
    layout: "/tenant",
    sidebar: true,
  },
  {
    path: "/add-tenant",
    name: "Add Organization",
    icon: "ni ni-fat-add text-primary",
    component: <AddTenant />,
    layout: "/tenant",
  },
  {
    path: "/edit-tenant",
    name: "Edit Organization",
    icon: "ni ni-building text-primary",   // will be shown in sidebar (if sidebar is enabled)
    component: <EditTenant />,
    layout: "/tenant",
    sidebar: false,   // or false if you prefer full‑width
  },
  {
    path: "/subscribe",
    name: "Subscription",
    icon: "ni ni-credit-card text-info",
    component: <SubscriptionPage />,
    layout: "/tenant",
    sidebar: false,   // full width, clean checkout experience
  },
  {
    path: "/payment/success",
    name: "Payment Success",
    icon: "ni ni-check-bold text-success",
    component: <PaymentSuccess />,
    layout: "/tenant",
    sidebar: false,
  },
  {
    path: "/payment/cancel",
    name: "Payment Cancelled",
    icon: "ni ni-fat-remove text-danger",
    component: <PaymentCancel />,
    layout: "/tenant",
    sidebar: false,
  },
  {
  path: "/branches/add",
  name: "Add Branch",
  icon: "ni ni-fat-add",
  component: <BranchForm />,
  layout: "/tenant",
  sidebar: false,
},
{
  path: "/branches/edit/:id",
  name: "Edit Branch",
  icon: "ni ni-settings",
  component: <BranchForm />,
  layout: "/tenant",
  sidebar: false,
},
{
  path: "/branches/:id",
  name: "Branch Detail",
  icon: "ni ni-building",
  component: <BranchDetail />,
  layout: "/tenant",
  sidebar: false,
},
{
  path: "/categories",
  name: "Categories",
  icon: "ni ni-bullet-list-67 text-primary",
  component: <CategoriesList />,
  layout: "/tenant",
  sidebar: true,
},
{
  path: "/categories/:id",
  name: "Category Detail",
  icon: "ni ni-building",
  component: <CategoryDetail />,
  layout: "/tenant",
  sidebar: false,
},
{
    path: "/profile",
    name: "User Profile",
    icon: "ni ni-single-02 text-yellow",
    component: <Profile />,
    layout: "/tenant",
    sidebar: false,
  },
  {
    path: "/agent",
    name: "Agent",
    icon: "ni ni-single-02 text-yellow",
    component: <AgentChat />,
    layout: "/tenant",
    sidebar: false,
  },
  
  //   {
  //     path: "/subscription",
  //     name: "Subscription",
  //     icon: "ni ni-credit-card text-info",
  //     component: <SubscriptionPage />,
  //     layout: "/tenant",
  //   },
  //   {
  //     path: "/branches",
  //     name: "Branches",
  //     icon: "ni ni-building text-success",
  //     component: <Branches />,
  //     layout: "/tenant",
  //   },
  //   {
  //     path: "/users",
  //     name: "Users",
  //     icon: "ni ni-single-02 text-warning",
  //     component: <Users />,
  //     layout: "/tenant",
  //   },
];
export default tenantRoutes;